
var sprite = require("/home/jenkins/agent/workspace/rod-authoring-homepage-ui_master/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20\" id=\"Clock-20px-Glance\" ><path d=\"M14.5 11H11V5.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V12h4.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z\"/><path d=\"M10.5 2.2c4.6 0 8.3 3.7 8.3 8.3s-3.7 8.3-8.3 8.3-8.3-3.7-8.3-8.3 3.7-8.3 8.3-8.3m0-1.2C5.3 1 1 5.3 1 10.5S5.3 20 10.5 20s9.5-4.3 9.5-9.5S15.7 1 10.5 1z\"/></symbol>";
module.exports = sprite.add(image, "Clock-20px-Glance");


//////////////////
// WEBPACK FOOTER
// ./app/common/icons/Clock-20px-Glance.svg
// module id = 111
// module chunks = 0